(function () {
    'use strict';

	/*
	 PublicController
	-------------------------------------------------------------------------- */

    angular
        .module('PublicApp.master', [])
        .controller('PublicController', [
            '$rootScope',
            '$scope',
            '__Auth',
            'appServices',
            'appNotify',
            '__DataStore',
            '$state',
            '$compile',
            '__Utils',
            '$q',
            PublicController
        ]);

	/**
	 * PublicController for main page application
	 *
	 * @inject __Auth
	 * @inject $rootScope
	 * @inject appServices
	 * @inject $scope
	 * 
	 * @return void
	 *-------------------------------------------------------- */

    function PublicController($rootScope, $scope, __Auth, appServices
        , appNotify, __DataStore, $state, $compile, __Utils, $q) {

        var scope = this;

        __Auth.refresh(function (authInfo) {
            scope.auth_info = authInfo;

        });

        scope.unhandledError = function () {

            appNotify.error(__globals.getReactionMessage(19)); // Unhandled errors

        };

        $rootScope.$on('lw.events.state.change_start', function () {
            appServices.closeAllDialog();
        });

        $rootScope.$on('lw.auth.event.reset', function (event, authInfo) {
            scope.auth_info = authInfo;
        });

        $rootScope.$on('lw.form.event.process.started', function (event, data) {
            $('button.lw-btn-process span').addClass('fa fa-spinner fa-spin');
            $('button.lw-btn-process').prop("disabled", true);

        });

        $rootScope.$on('lw.form.event.process.finished', function (event, data) {

            $('button.lw-btn-process span').removeClass('fa fa-spinner fa-spin');
            $('button.lw-btn-process').prop("disabled", false);

        });

        $rootScope.$on('lw.form.event.fetch.started', __globals.showFormLoader);

        $rootScope.$on('lw.datastore.event.fetch.finished', __globals.hideFormLoader);

        $rootScope.$on('lw.form.event.process.error', scope.unhandledError);

        $rootScope.$on('lw.datastore.event.fetch.error', scope.unhandledError);

        $rootScope.$on('lw.update.cart.string', function (event, data) {

            scope.cart_string = data.cart_string;
            scope.status = data.status;

            if (scope.status == true) {

                $('.lw-shopping-cart-btn').fadeIn("highlight", '#FFF', 5000
                );
                scope.getCartString();
            }

            if (_.has(data, 'showNotification')) {
                scope.toggleShoppinCartButtonShow();
            }

        });

        //product compare count event
        $rootScope.$on('lw.product.compare.count', function (event, data) {

            if (data) {
                scope.getProductCompareCount();
            }

        });

        scope.store_info = window.store_info;
        $rootScope.isPublicApp = window.__appImmutables.publicApp;

        scope.formatAmount = function (amount, currencySymbol, currency, decimalValue) {

            return __globals.priceFormat(amount, currencySymbol, currency);

        };

        $.typeahead({
            input: '.lw-product-search-input',
            minLength: 1,
            order: "asc",
            dynamic: true,
            delay: 500,
            hint: false,
            searchOnFocus: false,
            emptyTemplate: "no search result found",
            source: {
                searchResult: {
                    display: "name",
                    ajax: function (query, callback) {

                        return {
                            type: "GET",
                            path: "searchResult",
                            url: __Utils.apiURL({
                                'apiURL': 'product.suggest.search',
                                'searchQuery': query
                            }),
                            callback: {
                                done: function (responseData) {
                                    ;
                                    return responseData.data;
                                }
                            }
                        }
                    },
                }
            },
            callback: {
                onClick: function (node, a, item, event) {
                    event.preventDefault();
                    window.location = item.searchUrl;
                },
                onSubmit: function (node, form, item, event) {
                    event.preventDefault();

                    var searchTerm = $('#lw-product-search-input').val();
                    if (searchTerm) {
                        window.location = __Utils.apiURL('product.search') + '?search_term=' + searchTerm
                    }
                }
            },
            debug: true
        });

        scope.dialogStatus = false;
        //product quick view dialog
        scope.showDetailsDialog = function (eventObj, productId) {
            appServices.showDialog({
                categoryID: null,
                productID: productId,
                pageType: '',
                dialogStatus: scope.dialogStatus
            },
                {
                    templateUrl: __globals.getTemplateURL(
                        'product.details-dialog'
                    ),
                    controller: "ProductDetailsDialogController as productDetailsDialogCtrl",
                    resolve: {

                        GetProductDetails: function () {

                            //create a differed object          
                            var defferedObject = $q.defer();

                            __DataStore.fetch({
                                'apiURL': 'product.quick.view.details.support_data',
                                'productID': productId,
                                'categoryID?': scope.categoryID
                            }, { 'fresh': true }).success(function (responseData) {

                                appServices.processResponse(responseData, null, function (reactionCode) {

                                    //this method calls when the require        
                                    //work has completed successfully        
                                    //and results are returned to client        
                                    defferedObject.resolve(responseData);

                                });

                            });

                            //return promise to caller          
                            return defferedObject.promise;
                        }
                    }
                },
                function (promiseObj) {

                });
        };

        //add product compare function start
        scope.addProductCompare = function (productId) {

            __DataStore.post({
                'apiURL': 'product.compare.add',
                'productId': productId
            }, scope).success(function (responseData) {

                var requestData = responseData.data;
                appServices.processResponse(responseData, null, function (reactionCode) {
                    if (reactionCode == 1) {
                        var countCompareProduct = requestData.countCompareProduct;
                        $scope.$emit('lw.product.compare.count', true);
                    }

                });

            });
        }
        //add product compare function end

        /**
        * set page title
        *
        * @param title
        *
        * @return string
        *---------------------------------------------------------------- */

        scope.setDocumentPageTitle = function (title) {

            var newTitle;

            if (_.isEmpty(scope.store_info.value)) {

                newTitle = title;

            } else {
                newTitle = scope.store_info.value + ' - ' + title;
            }

            angular.element(document).prop('title', newTitle);

        };

        scope.store_info = window.store_info;


        $rootScope.$on('lw.current.route.name', function (event, result) {
            scope.routeStatus = result.routeStatus;

        });

        scope.themeColors = __globals.getAppImmutables('config')['theme_colors'];

        /**
        * Set Theme color
        *---------------------------------------------------------------- */
        scope.setThemeColor = function (colorName) {
            __DataStore.fetch({
                'apiURL': 'theme_color',
                'colorName': colorName
            }).success(function (responseData) {
                $('div.lw-store-header, div.lw-current-logo-conatiner').css('background-color', '#' + responseData);
            });
        }

        scope.showCurrencyNotification = function (message) {
            appNotify.info(message, { duration: 5000 });
        }

        scope.showHideThemeContainer = function () {
            if (!$('.lw-theme-color-container').hasClass('lw-theme-container-active')) {
                $('.lw-theme-color-container').addClass('lw-theme-container-active');
                $('.lw-switch i:first').replaceWith("<span>&times;</span>");
            } else {
                $('.lw-theme-color-container').removeClass('lw-theme-container-active');
                $('.lw-switch span:first').replaceWith("<i class='fa fa-cog'></i>");
            }
        }

        /**
        * open cart model
        *
        * @param object param1 type 
        *
        * @return void
        *---------------------------------------------------------------- */

        scope.showloginDialog = function () {
            var routeName = scope.auth_info.currentRouteName;

            //check if login dialog is open, if true then will not re-open again
            if (!($("html").hasClass("lw-public-login-page-active"))) {

                $('html').addClass('lw-public-login-page-active');
                if (routeName != 'user.login') {
                    appServices.loginRequiredDialog('login-dialog', null, function (result) {
                        $('html').removeClass('lw-public-login-page-active');
                        __DataStore.reset();

                        if (result) {
                            $("#lwLoginBtn").hide();
                            $("#lwRegisterBtn").hide();
                            // $state.reload();
                            $rootScope.$broadcast('lw.login-success', true);
                        }

                    });
                }
            }
        }

        /**
        * open cart model
        *
        * @param object param1 type 
        *
        * @return void
        *---------------------------------------------------------------- */

        scope.openCartDialog = function (status) {
            $rootScope.$broadcast('lw.isCart.dialog', { dialog: status });

            if (status == true) {

                $('html, body').animate({
                    scrollTop: $("#elementtoScrollToID").offset().top
                }, 200);

            } else {

                //check if shopping cart dialog is open, if true then will not re-open again
                if (!($("html").hasClass("lw-shopping-cart-dialog-active"))) {

                    $('html').addClass('lw-shopping-cart-dialog-active');

                    appServices.showDialog(scope,
                        {
                            templateUrl: __globals.getTemplateURL('shoppingCart.cart-view')
                        },
                        function (promiseObj) {
                            $('html').removeClass('lw-shopping-cart-dialog-active');
                        });

                    $rootScope.$on('ngDialog.opened', function (e, $dialog) {

                        if ($('div.lw-shopping-cart-dialog-content').length) {
                            $('div.ngdialog-content').addClass('lw-shopping-cart-dialog');
                        }

                    });
                }

            }
        };

        /**
       * product compare count event
       *
       * @return void
       *------------------------------------------------------------------------ */
        scope.loadCartStatus = false;

        scope.getProductCompareCount = function (showNotification) {

            // get data using angular $http.get() method
            __DataStore.fetch('product.compare.read.product_count')
                .success(function (responseData) {

                    var requestData = responseData.data;
                    appServices.processResponse(responseData, null,
                        function (reactionCode) {
                            scope.totalProductCompare = requestData.totalProductCompare;
                        }
                    );

                });

        };
        // scope.getProductCompareCount();

        /**
       * remove all product compare
       *
       * @return void
       *------------------------------------------------------------------------ */
        scope.removeAllProductInComapre = function () {
            __DataStore.post({
                'apiURL': 'product.compare.remove_all'
            }, scope).success(function (responseData) {

                var requestData = responseData.data;
                appServices.processResponse(responseData, null, function (reactionCode) {
                    if (reactionCode == 1) {
                        var countCompareProduct = requestData.countCompareProduct;
                        $scope.$emit('lw.product.compare.count', true);
                    }

                });

            });
        };


        /**
	    * get cart btn string
	    *
	    * @return void
	    *------------------------------------------------------------------------ */
        scope.loadCartStatus = false;

        scope.getCartString = function (showNotification) {

            // get data using angular $http.get() method
            __DataStore.fetch('cart.update.cart.string')
                .success(function (responseData) {

                    appServices.processResponse(responseData, null,
                        function (reactionCode) {

                            scope.cart_string = responseData.data.cartString;
                            scope.cartData = responseData.data.cartItems;
                            scope.totalItems = responseData.data.totalItems;
                            scope.cartTotal = responseData.data.cartTotal;
                            scope.loadPage = responseData.reaction;
                            scope.loadCartStatus = true;

                            scope.totalProductCompare = responseData.data.totalProductCompare;
                            if (scope.status === true) {

                                // $('.shopping-cart-btn').effect(
                                //             "highlight", 
                                //             '#FFF',
                                //             5000
                                //         );
                            }

                            if (showNotification) {
                                scope.toggleShoppinCartButtonShow()
                            }
                        }
                    );

                });

        };
        scope.getCartString();

		/**
          * Show hide shopping cart button
          *
          * @return void 
          *---------------------------------------------------------------- */

        scope.toggleShoppinCartButtonShow = function () {

            var $dynamicShoppingCartBtn = $('.lw-dynamic-shopping-cart-btn').addClass('lw-bring-in-light'),
                delayTimer = _.delay(function () {
                    $dynamicShoppingCartBtn.removeClass('lw-bring-in-light');
                }, 3000);

            $dynamicShoppingCartBtn.hover(function () {
                clearInterval(delayTimer);
            }, function () {
                $dynamicShoppingCartBtn.removeClass('lw-bring-in-light');
            });
        };

        /**
          * Check if user logged in
          *
          * @return boolean 
          *---------------------------------------------------------------- */

        scope.isLoggedIn = function () {
            return scope.auth_info.authorized;     // is looged in
        };

		/**
          * Check if user logged in
          *
          * @return boolean 
          *---------------------------------------------------------------- */

        $rootScope.isLoggedIn = function () {
            return scope.auth_info.authorized;     // is looged in
        };

        /**
          * Check if user logged in
          *
          * @return boolean 
          *---------------------------------------------------------------- */

        scope.isAdmin = function () {
            return scope.isLoggedIn() && scope.auth_info.designation === 1;   //check if is admin
        };

        /**
          * Get the logged in user full name
          *
          * @return string 
          *---------------------------------------------------------------- */

        scope.getUserFullName = function () {

            if (scope.isLoggedIn()) {
                return scope.auth_info.profile.first_name + ' ' + scope.auth_info.profile.last_name;
            }

        };

        $rootScope.$on('lw-open-login-dialog', function (event, response) {

            event.preventDefault();

            appServices.loginRequiredDialog('login-dialog', response.data, function (result, newData) {

                __DataStore.reset();

                if (result) {

                    // $state.reload();
                    $rootScope.$broadcast('lw.login-success', true);
                }

            });

        });

    };

})();